<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="zonaClass">
    <app-contenedor-elementos [header]="{
      title: ''
    }">
      <div body class="w3-row" [ngClass]="{'w3-disabled':isDownloadingData || isLoadingObtenerDatos }">
        <mat-expansion-panel expanded="true">
          <div style="display: flex; flex-direction: row; gap: 10px; padding-top: 20px; flex-wrap: wrap;">
            <div class="container-menu">
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramFecha' | translate}}</div>
              <div class="w3-row"> 
                <app-filters 
                  [name]="'filtros.fin' | translate"
                  [array]="periodos"
                  [typeFilter]="Filters.PERIOD"
                  (eventClick)="anioChange($event)">
                </app-filters>
              </div>
              <div class="tituloFiltros" style="height: 10%;"></div>
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramOpt' | translate}}</div>                    
              <div class="w3-row" style="margin-left: 20px;">{{'gestion.reportes.avance.etiquetaOpt' | translate}} 
                <mat-slide-toggle [(ngModel)]="porPeriodo" labelPosition="after" (change)="cambioPorPeriodo();"></mat-slide-toggle>
              </div>
              @if (porPeriodo) {
                <div class="w3-row" style="margin-left: 20px; margin-top: 10px;">{{'gestion.reportes.avance.numPer' | translate}} 
                  <input id="numPer" class="inputTable" (change)="cambioPeriodos();" (keyup)="cambioPeriodos();" 
                  type="number" max="12" min="1" value="{{numPeridos}}" style="margin-left: 10px;">
                </div>
                <div class="chips" id="Cchip" style="margin-top: 10px;">
                  <div class="auto_ajuste" style="display: flex; justify-content: center;">
                    <div class="w3-round-btn-large grisBtn w3-center w3-elemento-menu filtroMesAnioSeleccionado">
                      <span style="margin-left: 5px; margin-right: 5px;">{{perImpresion()}}</span>
                    </div>
                    <span style="margin-left: 5%; margin-right: 3%;"> <strong> &#8212; </strong></span>
                    <div class="w3-round-btn-large grisBtn w3-center w3-elemento-menu filtroMesAnioSeleccionado">
                      <span style="margin-left: 5px; margin-right: 5px;">{{getPeriod()}}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="container-menu">
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramImp' | translate}}</div>
              <div>
                <div class="togElement">                  
                  <mat-slide-toggle labelPosition="before" id="st_introduccion" [(ngModel)]="imprimirIntro">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt1' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                @if (verFodaV1) {
                  <div class="togElement">
                    <mat-slide-toggle labelPosition="before" id="st_foda" [(ngModel)]="imprimirFoda">
                      <div style="width: 12vw;">{{'gestion.reportes.avance.opt2' | translate}}</div>
                    </mat-slide-toggle>
                  </div>
                }
                @if (verFodaV2) {
                  <div class="togElement">
                    <mat-slide-toggle labelPosition="before" id="st_fodav2" [(ngModel)]="imprimirFodaV2">
                      <div style="width: 12vw;">{{'gestion.reportes.avance.opt3' | translate}}</div>
                    </mat-slide-toggle>
                  </div>
                }                
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_objetivos" [(ngModel)]="imprimirObjetivos">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt4' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_indicadores" [(ngModel)]="imprimirIndicadores">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt5' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_planOperativo" [(ngModel)]="imprimirPlanOperativo">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt6' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_planOperativoActividades" [(ngModel)]="imprimirPlanOperativoActividades">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt7' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_planActividades" [(ngModel)]="imprimirPlanActas">
                    <div style="width: 12vw;">{{tableroAct}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_cmi" [(ngModel)]="imprimirCmi">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt10' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                <div class="togElement">
                  <mat-slide-toggle labelPosition="before" id="st_graficas" [(ngModel)]="imprimirGraficas">
                    <div style="width: 12vw;">{{'gestion.reportes.avance.opt11' | translate}}</div>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
            <div class="container-menu">
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramPers' | translate}}</div>
              <div class="togElement">
                <mat-slide-toggle labelPosition="before" [(ngModel)]="todasPerIM" (ngModelChange)="selecAllPerIM(todasPerIM)">
                  <div style="width: 12vw;">{{'filtros.todas' | translate}}</div>
                </mat-slide-toggle>
              </div>
              @if (!todasPerIM) {
                @for (per of perspectivas; track $index) {
                  <div class="togElement">
                    <mat-slide-toggle labelPosition="before" [id]="'per'+per.name" [(ngModel)]="per.check"
                      (ngModelChange)="cambioPerIM(per)">
                      <div style=" width: 12vw;">{{per.name}}</div>
                    </mat-slide-toggle>
                  </div>
                }
              }
            </div>
            <div class="container-menu">
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramObj' | translate}}</div>
              <div>
                <div class="togElement" [ngClass]="{ 'w3-disabled': persSeleccionadas.length !== 1 }">
                  <mat-slide-toggle labelPosition="before" id="todosObj" [(ngModel)]="todosObjetivos"
                    (ngModelChange)="selectAllObjetivos(todosObjetivos)" [disabled]="persSeleccionadas.length !== 1">
                    <div style="width: 12vw;" >{{'gestion.reportes.avance.selectAll' | translate}}</div>
                  </mat-slide-toggle>
                </div>
                @if (!todosObjetivos) {
                  @for (obj of objectivos; track $index) {
                    @if (persSeleccionadas.length === 1 && persSeleccionadas[0].id === obj.idPer) {
                      <div class="togElement">
                        <mat-slide-toggle labelPosition="before" [id]="obj.nombre" [(ngModel)]="obj.check"
                          (ngModelChange)="cambioObj(obj)">
                          <div style="width: 12vw;">{{obj.nombre}}</div>
                        </mat-slide-toggle>
                      </div>
                    }                    
                  }
                }
              </div>
            </div>
            <div class="container-menu">
              <div class="tituloFiltros">{{'gestion.reportes.avance.paramLider' | translate}}</div>
              <div class="togElement">
                <mat-slide-toggle labelPosition="before" id="todosLideres" [(ngModel)]="todosLideresSeleccionados"
                  (ngModelChange)="selecciondarTodosLideres(todosLideresSeleccionados)">
                  <div style="width: 12vw;" >{{'gestion.reportes.avance.selectAll' | translate}}</div>
                </mat-slide-toggle>
              </div>
              @if (!todosLideresSeleccionados) {
                @for (res of lideres; track $index) {
                  <div class="togElement">
                    <mat-slide-toggle labelPosition="before" [id]="res.name" [(ngModel)]="res.check"
                      (ngModelChange)="cambioLiderIM(res)">
                      <div style="width: 12vw;">{{res.name}}</div>
                    </mat-slide-toggle>
                  </div>
                }
              }
            </div>
          </div>
          <mat-action-row>
            <div style="float: right; margin-bottom: 50px;">
              <ng-template [ngIf]="isDownloadingPdf"><span
                  style="padding-top: 15px; font-size: .6rem; color: #808080;">{{'gestion.reportes.avance.descargando' | translate}}</span></ng-template>
              <ng-template [ngIf]="isDownloadingData || isLoadingObtenerDatos">
                <span style="padding-top: 15px; font-size: .6rem; color: #808080;">
                  {{'gestion.reportes.avance.cargando' | translate}}
                </span></ng-template>
              <ng-template [ngIf]="!isDownloadingPdf && !isDownloadingData && !isLoadingObtenerDatos">
                <button
                  style="display: flex; flex-wrap: wrap; height: 50px; width: 100px; align-items: center; justify-content: center; background-color: transparent; border: none; cursor: pointer;"
                  (click)="generarReporte()">
                  <span style="font-size: .6rem; color: #080707;">{{'gestion.reportes.avance.descargar' | translate}}</span>
                  <mat-icon
                    style="font-size: 3rem; color: #ED7D31; width: 3rem; height: 3rem;">cloud_download</mat-icon>
                </button>
              </ng-template>

            </div>
            <ng-template [ngIf]="!isDownloadingPdf && !isDownloadingData && !isLoadingObtenerDatos">
              <div style="float: right; margin-bottom: 50px;">
                <button style="display: flex; flex-wrap: wrap; height: 50px; width: 100px; background-color: transparent; border: none; cursor: pointer; justify-content: center;"
                  (click)="abrirFormEnviarEmail()">
                  <span style="font-size: .6rem; color: #080707;">{{'gestion.reportes.avance.enviarE' | translate}}</span>
                  <mat-icon style="font-size: 3rem; color: #ED7D31; width: 3rem; height: 3rem;">email</mat-icon>
                </button>
              </div>
            </ng-template>
          </mat-action-row>
          <mat-action-row>
          </mat-action-row>
        </mat-expansion-panel>
      </div>       
    </app-contenedor-elementos>
  </div>
</app-esqueleto-tableros>

<!-- <div class="w3-row" id="cont_graf" style="opacity: 0.0; position: absolute; left: -1000px; bottom:0;">
  @for (graf of graficas_lineales; track $index) {
    @if (graf.series.length !== 0 && graf.check) {
      <div style="width: 800px;" [id]="'graf'+graf.indicadorId" class="w3-row contGraf">
        <div style="font-size: 1rem; margin-bottom: 20px;">{{graf.name}}</div>
        <app-grafica-lineal [DatosGraf]="graf.series" [indicadorId]="graf.indicadorId" [name]="graf.name"></app-grafica-lineal>
      </div>
      <div class="w3-row" style="height: 4vh;"></div>
    }
  }
</div>

<div id="floa_img_cont" style="display: none;">
  <img id="floa_img" #floa_img style="width: 500px;" src="assets/img/reportes/FODA.png" alt="">
</div> -->

<div id="formEnviarEmail" class="w3-modal">
  <div class="w3-modal-content" style="width: 50vw; ">
    <form (ngSubmit)="enviarFormEmail()" autocomplete="off" #miFormulario="ngForm" class="row justify-content-center" style="padding: 10%;">
      <label class="fs-3 mb-5">{{'gestion.reportes.avance.enviarTit' | translate}}</label>
      <div class="mb-3 row">
          <label class="col-sm-3 col-form-label">{{'gestion.reportes.avance.email' | translate}}</label>
          <div class="col-sm-9">
            <div class="input-group">
              <input type="text" class="form-control"
                placeholder="{{'gestion.reportes.avance.emailtt' | translate}}"
                [(ngModel)]="nuevoEmail"
                (keyup.enter)="agregarEmail()"
                name="nuevoJuego">
              <button class="btn" type="button" (click)="agregarEmail()" style="background-color: #4E9AC7; color: white;">
                {{'gestion.reportes.avance.agregar' | translate}}
              </button>
            </div>
          </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-3 col-form-label">{{'gestion.reportes.avance.listado' | translate}}</label>
        <div class="col-sm-9">
          @for (email of emailsControl.emails; track email; let i = $index) {
            <div class="input-group mb-1">
              <input  [(ngModel)]="email.email"
                name="email_{{ i}}" class="form-control" required>
                <button class="btn btn-outline-danger" type="button" (click)="eliminar(i)">
                  {{'gestion.reportes.avance.eliminar' | translate}}
                </button>
            </div>
          }
          
        </div>
      </div>

      <div class="row">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button type="button" class="btn float-end me-md-1" [disabled]="miFormulario.invalid"
          (click)="enviarFormEmail()" style="background-color: #ED7D31; color: white;">{{'gestion.reportes.avance.enviar' | translate}}</button>
          <button type="button" class="btn float-end"
            (click)="cerrarFormEnviarEmail()" style="background-color: #B9B9BC; color: white;">{{'swal.cerr' | translate}}</button>
        </div>
      </div>
  </form>
    <div class="w3-rest">
      <mat-icon (click)="cerrarFormEnviarEmail();" class="w3-button w3-display-topright" style="margin-top: 18px;margin-right: 24px;">clear</mat-icon>
    </div>
  </div>
</div>